import { http } from '@api/client';
import { paramterize, pickResponse, pickResult } from '@api/utils';
import { CompanyContentRelation } from '@lib/company-content-relations';
import { NOT_SURE } from 'pages/company-to-person/edit/form';
import { toMarketsPayload } from 'pages/company-to-person/c2p-features/markets-responsible-field';

export interface CompanyPersonRelation {
  gender: number;
  imdb_id: string;
  person_name: string;
  designation: string;
  deal_role: string;
  ingestion_method: string;
  currently_working: string;
  source: string;
  modified_at: string | null;
  person_tmdb_id: number;
  popularity: number;
  profile_path: string;
  projects_count: number;
  role_id: string;
  vtr_id: string;
  count: number | null;
  deal_count: number;
  content_count: number;
  companies_associated: [];
}

export function get(vtr_relation_id: string) {
  return http.get(`/company-person-relation/${vtr_relation_id}`).pipe(pickResult());
}
type EditC2PPayload = {
  person_vtr_id: string;
  company_vtr_id: string;
  designation: string;
  currently_working: string;
  markets_responsible?: string;
};

export function post(payload) {
  const associated_person = payload?.associated_person?.map(person => {
    const markets = person?.markets_responsible;
    const hasMarkets = Array.isArray(markets) ? markets.length > 0 : Boolean(markets);
    return {
      person_vtr_id: person?.vtr_id,
      designation: person?.designation ||person?.meta?.designation || '',
      currently_working: person?.currently_working ?? 'yes',
      markets_responsible: toMarketsPayload(
        hasMarkets ? markets : person?.meta?.markets_responsible || ''
      ),
    };
  });

  const c2pPayload = {
    company_vtr_id: payload?.buyers[0]?.vtr_id ?? '',
    associated_person,
    description:payload?.description ?? "", //adding descritption to c2p
    source_links: payload?.sources ?? "",
  };
  return http.post(`/company-person-relation`, c2pPayload).pipe(pickResult());
}

export function put(person_company_rel_id = '', payload) {
  if (payload?.currently_working === NOT_SURE) {
    payload.currently_working = '';
  }
  if (payload?.markets_responsible != null) {
    payload.markets_responsible = toMarketsPayload(payload.markets_responsible);
  }
  return http.put(`/company-person-relation/${person_company_rel_id}`, payload).pipe(pickResult());
}

export function deleteC2P({ person_company_rel_id = '' }: { person_company_rel_id: string }) {
  return http.delete(`/company-person-relation/${person_company_rel_id}`).pipe(pickResult());
}
